import React from 'react';
import styled from 'styled-components';
import ContentContainer from './ContentContainer';
import ImageOverhangContainer from './imageContentContainer/ImageOverhangContainer';
import ImageWrapper from './imageContentContainer/ImageWrapper';
import Image from './imageContentContainer/Image';
import { spacing } from '../style/theme';
var Content = styled.div.withConfig({
  displayName: "ImageContentContainer__Content",
  componentId: "sc-1919zn-0"
})(["max-width:calc(50% - ", "px);padding-top:", "px;padding-bottom:", "px;@media only screen and (max-width:", "px){max-width:initial;padding-top:0;padding-bottom:0;margin-bottom:", "px;}"], spacing.base * 2, function (_ref) {
  var spacingMultiplier = _ref.spacingMultiplier;
  return spacing.base * (spacingMultiplier || 5);
}, function (_ref2) {
  var spacingMultiplier = _ref2.spacingMultiplier;
  return spacing.base * (spacingMultiplier || 5);
}, spacing.collapseMenuWidth, spacing.base);
var Container = styled.div.withConfig({
  displayName: "ImageContentContainer__Container",
  componentId: "sc-1919zn-1"
})(["margin-top:", "px;margin-bottom:", "px;position:relative;@media only screen and (max-width:", "px){margin-top:", "px;}"], spacing.base * 2, spacing.base * 2, spacing.collapseMenuWidth, spacing.base);

var getContentMargin = function getContentMargin(rightToLeft) {
  return rightToLeft ? {
    marginLeft: 'auto'
  } : {
    marginRight: 'auto'
  };
};

var ImageContentContainer = function ImageContentContainer(_ref3) {
  var rightToLeft = _ref3.rightToLeft,
      children = _ref3.children,
      imageOverhang = _ref3.imageOverhang,
      image = _ref3.image,
      image2x = _ref3.image2x,
      alt = _ref3.alt,
      spacingMultiplier = _ref3.spacingMultiplier,
      imageOpposite = _ref3.imageOpposite,
      imageStyle = _ref3.imageStyle;
  return React.createElement(Container, {
    rightToLeft: rightToLeft
  }, React.createElement(ContentContainer, null, React.createElement(Content, {
    style: getContentMargin(rightToLeft),
    spacingMultiplier: spacingMultiplier
  }, children)), !imageOverhang && image && React.createElement(ImageWrapper, {
    rightToLeft: rightToLeft
  }, React.createElement(Image, {
    src: image,
    srcSet: image2x ? image + " 1x, " + image2x + " 2x" : undefined,
    rightToLeft: rightToLeft,
    alt: alt,
    style: imageStyle
  })), image && imageOverhang && React.createElement(ImageOverhangContainer, {
    image: image,
    image2x: image2x,
    rightToLeft: rightToLeft,
    imageOpposite: imageOpposite,
    alt: alt
  }));
};

export default ImageContentContainer;